import { useEffect, useRef, useState } from "react";
import { CloudOff, RefreshCw } from "lucide-react";
import { subscribeSync, flushQueue } from "@/lib/offlineQueue";

export const PendingSyncIndicator = ({ onSynced }) => {
  const [state, setState] = useState({ online: true, pending: 0 });
  const prevPending = useRef(0);

  useEffect(() => subscribeSync((next) => {
    if (prevPending.current > 0 && next.pending === 0 && next.online) onSynced?.();
    prevPending.current = next.pending;
    setState(next);
  }), [onSynced]);

  if (state.online && state.pending === 0) return <div className="w-12" />;
  return (
    <button type="button" onClick={() => flushQueue()}
            className="flex items-center gap-1 rounded-full bg-amber-400/90 px-2 py-1 text-[10px] font-bold text-zinc-900"
            data-testid="pending-sync-indicator">
      {state.online ? <RefreshCw className="w-3 h-3 animate-spin" /> : <CloudOff className="w-3 h-3" />}
      {state.pending > 0 ? `${state.pending} pending sync` : "Offline"}
    </button>
  );
};
